import { useState } from 'react';
import { Info, Route } from 'lucide-react';
import { CrmDealAccordion } from './CrmDealAccordion';
import { ONVIZ_JOURNEY_STEPS } from '../../../lib/onvizOrderJourney';

export function CrmManagerGuide() {
  const [open, setOpen] = useState(false);
  return (
    <CrmDealAccordion
      macroId="sales"
      title="Как вести заказ до закрытия"
      subtitle="Маршрут Onviz · 10 шагов"
      accent="#63B3ED"
      icon={<Info size={15} color="#63B3ED" />}
      open={open}
      onOpenChange={setOpen}
      defaultOpen={false}
    >
      <div className="space-y-3 text-[11px] leading-relaxed" style={{ color: 'var(--text-2)' }}>
        <div
          className="rounded-xl p-3 flex gap-2"
          style={{ background: 'rgba(99,179,237,0.1)', border: '1px solid rgba(99,179,237,0.28)' }}
        >
          <Route size={16} className="shrink-0 mt-0.5" style={{ color: '#63B3ED' }} />
          <div>
            <p className="font-bold mb-1" style={{ color: 'var(--text-1)' }}>
              Два рычага — не путать
            </p>
            <p>
              <b>Этапы воронки</b> (блок «Продажи») — где вы в сделке: замер, состав, выдача. Сообщение
              клиенту — шаблон про этап.
              <br />
              <b>Статус для клиента</b> (блок «Операции» или вкладка «Заказы») — как в мини-апп:
              «в работе», «в производстве», «закрыт». Другое сообщение в Telegram.
            </p>
          </div>
        </div>

        <ol className="space-y-2 list-decimal list-inside">
          {ONVIZ_JOURNEY_STEPS.map((step) => (
            <li key={step.stage}>
              <span className="font-bold" style={{ color: 'var(--text-1)' }}>
                {step.label}
              </span>
              {' — '}
              {step.managerHint}
            </li>
          ))}
        </ol>

        <p className="text-[10px]" style={{ color: 'var(--text-3)' }}>
          Закрытие: этап «Выдача» → статус «Закрыт · выдан». Отказ — «Потеряна» (заказ отменится).
        </p>
      </div>
    </CrmDealAccordion>
  );
}
